const style = (theme) => ({
  root: {
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
    background: theme.color.background,
    boxSizing: 'border-box',
    overflow: 'hidden',
    paddingTop: 130,
    [theme.mq.md]: {
      paddingTop: 100,
    },

    '& h1': {
      color: theme.colors[2],
    },
  },
  rootDark: {
    background: theme.colors[9],
  },
  backLink: {
    position: 'absolute',
    zIndex: 10,
    top: theme.header.spacing[0],
    left: '50%',
    transform: 'translateX(-50%) rotate(90deg)',
    transformOrigin: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
    display: 'inline-block',
    borderRadius: '50%',
    [theme.mq.md]: {
      display: 'none',
    },
  },
})

export default style
